/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const recycledMaterialPercentageDtoCauseEnum = {
  "by-ingested-product-recycled-percentage":
    "by-ingested-product-recycled-percentage",
  "by-ingested-material-composition-recycled-percentage":
    "by-ingested-material-composition-recycled-percentage",
  "by-entered-components-recycled-percentage":
    "by-entered-components-recycled-percentage",
  "by-mixed-components-recycled-percentage":
    "by-mixed-components-recycled-percentage",
  "not-calculated": "not-calculated",
} as const

export type RecycledMaterialPercentageDtoCauseEnumKey =
  (typeof recycledMaterialPercentageDtoCauseEnum)[keyof typeof recycledMaterialPercentageDtoCauseEnum]

export type RecycledMaterialPercentageDto = {
  /**
   * @type number
   */
  percentage: number
  /**
   * @type string
   */
  cause: RecycledMaterialPercentageDtoCauseEnumKey
}
